import { combineReducers } from "redux";

//REDUCERS
import { reducer as abstracts } from "./abstracst.reducer";

export const reducer = combineReducers({
  abstracts,
});
